export default __webpack_public_path__ + "static/media/deliventure.664f3cd4.png";